import {
  Paper,
  Typography,
  makeStyles,
  Box,
  Container,
  Button,
  Chip
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Briefcase, Phone, Mail } from 'react-feather';
import {
  getSelfAction,
  getStaff,
  resetStaffPwd,
  toggleStaffStatus
} from 'src/store/actions/StaffActions';
import Page from 'src/components/Page';
import CustomModal from 'src/components/CustomModal';
import CreateStaff from './CreateStaff';
import UpdatePassword from './UpdatePassword';
import ProfileDataTable from './ProfileDataTable';
import CustomDataTable from '../../components/Table/CustomDataTable';
import UpdateAdmin from './UpdateAdmin';
import { toggleAdminStatusRequest } from 'src/api/StaffRequest';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    textAlign: 'center'
  },
  paperTable: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    textAlign: 'right'
  },
  otherInfo: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  datatable: {
    marginTop: theme.spacing(2)
  },
  box: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  userActions: {
    marginTop: theme.spacing(2)
  },
  table: {
    minWidth: 750
    // minHeight: 500
  },
  actionBtn: {
    marginRight: theme.spacing(1)
  }
}));

function StaffManager() {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [modalControl, setModalControl] = useState(false);
  const [modalData, setModalData] = useState(null);
  const staffData = useSelector((state) => state.Staff.staffData);
  const selfData = useSelector((state) => state.Staff.self);

  useEffect(() => {
    setLoading(true);
    async function callGetStaff() {
      const response = await dispatch(getStaff(profile));
      if (response) {
        setLoading(false);
      }
    }
    callGetStaff();
    dispatch(getSelfAction(profile));
  }, []);

  const handleModalOpen = (e, data) => {
    const currModalID = e.currentTarget.id;
    if (currModalID) setModalControl(currModalID);
    if (data) setModalData(data);
  };

  const closeModal = () => {
    setModalControl(false);
    setModalData(null);
  };

  const tableActions = () => (
    <Box>
      <Button
        id="create-staff"
        variant="contained"
        color="primary"
        onClick={handleModalOpen}
        style={{ marginRight: 10 }}
      >
        Create Staff
      </Button>
    </Box>
  );

  const tableConfig = [
    {
      title: 'S/N',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'Fullname',
      value: 'fullname',
      align: 'center'
    },

    {
      title: 'Username',
      value: 'username',
      align: 'center'
    },
    {
      title: 'Email',
      value: 'email',
      align: 'center'
    },
    {
      title: 'Phone',
      value: 'phone',
      align: 'center'
    },
    {
      title: 'Status',
      value: 'accessStatus',
      align: 'center',
      render: (item) => {
        if (item.accessStatus == 0) {
          return (
            <Chip
              variant="outlined"
              color="primary"
              size="small"
              label="Deactivated"
            />
          );
        }
        return (
          <Chip
            style={{ background: 'green', color: 'white' }}
            size="small"
            label="Active"
          />
        );
      }
    },
    profile?.usertype.toLowerCase() !== 'issuer_staff' && {
      title: 'Actions',
      value: '',
      align: 'center',
      render: (row, i) => (
        <Box>
          <Button
            id="create-staff"
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            onClick={(e) => handleModalOpen(e, row)}
          >
            Update
          </Button>
          <Button
            id="reset-password"
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            onClick={() => handleResetPassword(row.id)}
          >
            Reset Password
          </Button>
          <Button
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            onClick={() => handleToggleStatus(row)}
          >
            {row?.accessStatus == 1 ? 'Disable Account' : 'Enable Account'}
          </Button>
        </Box>
      )
    }
  ];

  const handleResetPassword = async (id) => {
    const reset = window.confirm(
      'Are you sure you want to reset this staff password?'
    );
    if (reset) {
      setButtonLoader(true);
      const response = await dispatch(resetStaffPwd(id, profile));
      if (response) setButtonLoader(false);
    }
  };

  const handleToggleStatus = async (row) => {
    const { id, accessStatus } = row;
    const status = accessStatus == 1 ? 0 : 1;
    const toggle = window.confirm(
      'Are you sure you want to toggle this staff status?'
    );
    if (toggle) {
      setButtonLoader(true);
      const response = await dispatch(
        toggleStaffStatus(id, { accessStatus: status }, profile)
      );
      if (response) setButtonLoader(false);
    }
  };

  return (
    <Page className={classes.root} title="Staff Manager">
      <Container maxWidth="lg">
        <Paper className={classes.paper}>
          <Typography variant="h2">{selfData?.fullname || '-'}</Typography>
          <Box className={classes.otherInfo}>
            <Box className={classes.otherInfo}>
              <Mail /> &nbsp;
              <Typography variant="h5">{selfData?.email || '-'}</Typography>
            </Box>

            <Box className={classes.otherInfo}>
              <Phone /> &nbsp;
              <Typography variant="h5">{selfData?.phone || '-'}</Typography>
            </Box>
          </Box>
          <Box className={classes.userActions}>
            <Button
              id="update-admin"
              variant="text"
              color="secondary"
              onClick={(e) => handleModalOpen(e, selfData)}
              style={{ marginRight: 10 }}
            >
              Update Staff
            </Button>
            <Button
              id="update-password"
              variant="text"
              color="secondary"
              onClick={handleModalOpen}
            >
              Update Password
            </Button>
          </Box>
        </Paper>

        <Box className={classes.datatable}>
          <CustomDataTable
            className={classes}
            tableData={staffData}
            tableConfig={tableConfig}
            tableActions={tableActions}
            loading={loading}
            filterField="username"
          />
        </Box>
      </Container>

      {/* Modals */}
      <CustomModal
        open={modalControl === 'create-staff'}
        handleClose={closeModal}
        modalData={modalData}
        title="Create Staff"
      >
        <CreateStaff handleClose={closeModal} modalData={modalData} />
      </CustomModal>

      <CustomModal
        open={modalControl === 'update-password'}
        handleClose={closeModal}
        title="Update Password"
      >
        <UpdatePassword handleClose={closeModal} />
      </CustomModal>

      <CustomModal
        open={modalControl === 'update-admin'}
        handleClose={closeModal}
        title="Update Admin"
      >
        <UpdateAdmin handleClose={closeModal} modalData={modalData} />
      </CustomModal>
    </Page>
  );
}

export default StaffManager;
